export const getMailForUser = ({ email, name }: { email: string; name: string }): string =>
  `mailto:${email}?subject=Hi%20${name}&body=Hi%20${name}`;
